module.exports = __webpack_public_path__ + "static/ApercuMonoProRegular-3ee60f80b47c3d2a2448b9cc3cffb58a.ttf";